module.exports = __webpack_public_path__ + "jobs-2ec46bc8/404-6b5a631fccc0149f72dd5d37e01692c7.svg";